import React from "react";
import PersonalDiary from "../../features/personaldiary";

const PersonalDiaryPage = () => <PersonalDiary />

export default PersonalDiaryPage;